/**
 * region for libraries*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar } from "@material-ui/core";

/**
 * region for styles*/
import { layoutKeywordAnalyzerStyle } from "./style/layoutKeywordAnalyzerStyle";

/**
 * region for components*/
 import HeaderTitle from '../../../components/common/HeaderTitle';

/**
 * region for containers*/
import KeywordAnalyzer from '../../../containers/keyword/KeywordAnalyzer';
/**
 * region for hepers*/

/**
 * region for constans*/

class LayoutKeywordAnalyzer extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar className={clsx(classes.appBar)} position="absolute" color="inherit" elevation={0}>
          <Toolbar>
            <HeaderTitle
              title={"Add Multiple Keywords"} />
          </Toolbar>
        </AppBar>
        <div className={classes.content}>
          <div className={classes.appBarSpacer} />
          <KeywordAnalyzer />
        </div>
      </div>
    );
  }
}
LayoutKeywordAnalyzer.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(layoutKeywordAnalyzerStyle)(LayoutKeywordAnalyzer);
